import { render, staticRenderFns } from "./EnterCode.vue?vue&type=template&id=bffedd90&scoped=true"
import script from "./EnterCode.vue?vue&type=script&lang=js"
export * from "./EnterCode.vue?vue&type=script&lang=js"
import style0 from "./EnterCode.vue?vue&type=style&index=0&id=bffedd90&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffedd90",
  null
  
)

export default component.exports